import axios from 'redaxios';

import slideDown from '../util/slide-down';
import slideUp from '../util/slide-up';

let sections = {};

const selectors = {
  wrapper: '[data-add-action-wrapper]',
  addButton: '[data-add-to-cart]',
  errors: '[data-add-action-errors]',
  addVariantDetached: 'data-add-to-cart-variant',
  popdown: '[data-product-add-popdown-wrapper]',
};

const classes = {
  loading: 'loading',
  success: 'has-success',
};

class ProductAddButton {
  constructor(wrapper, isCartItem) {
    this.wrapper = wrapper;
    this.isCartItem = isCartItem ? isCartItem : false;
    this.button = wrapper.querySelector(selectors.addButton);
    this.errors = wrapper.querySelector(selectors.errors);
    this.popdown = document.querySelector(selectors.popdown);

    if (this.button) {
      const isDetached = this.button.hasAttribute(selectors.addVariantDetached);
      if (isDetached) {
        this.initDetached();
      } else {
        this.initWithForm();
      }
    }
  }

  initWithForm() {
    this.button.addEventListener(
      'click',
      function (evt) {
        const outerForm = evt.target.closest('form');
        if (outerForm.querySelector('[type="file"]')) {
          return;
        }
        evt.preventDefault();

        this.button.setAttribute('disabled', true);
        this.button.classList.add(classes.loading);

        const formData = new FormData(outerForm);
        const formString = new URLSearchParams(formData).toString();
        this.addToCartAction(formString);
      }.bind(this)
    );
  }

  initDetached() {
    this.button.addEventListener(
      'click',
      function (evt) {
        evt.preventDefault();

        this.button.setAttribute('disabled', true);
        this.button.classList.add(classes.loading);

        const variant = this.button.getAttribute(selectors.addVariantDetached);
        const formString = `form_type=product&id=${variant}`;

        this.addToCartAction(formString);
      }.bind(this)
    );
  }

  addToCartAction(formData) {
    const url = `${window.theme.routes.cart}/add.js`;
    const instance = this;
    axios
      .post(url, formData, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then(function (response) {
        instance.onSuccess(response.data);
      })
      .catch(function (error) {
        console.warn(error);
        instance.onError(error.data);
      });
  }

  onSuccess(variant) {
    this.updateHeaderTotal();
    this.button.classList.remove(classes.loading);
    this.button.classList.add(classes.success);
    setTimeout(() => {
      this.button.classList.remove(classes.success);
      this.button.removeAttribute('disabled');
    }, 3500);

    if (this.isCartItem) {
      document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
    } else {
      const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (cartDrawer) {
        if( document.querySelector(`#QuickShopModal.is-open`) !== null ) {
          MicroModal.close('QuickShopModal');
        }

        document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
        setTimeout(function(){
          cartDrawer.dispatchEvent(
            new CustomEvent('theme:drawer:open', {
              bubbles: false,
            })
          );
        }, 600);

      } else {
        window.location.href = '/cart';
      }

      // this.popdown.dispatchEvent(
      //   new CustomEvent('theme:cart:popdown', {
      //     detail: {
      //       variant: variant,
      //     },
      //     bubbles: true,
      //   })
      // );
    }
  }

  onError(data) {
    let text = 'Network error: please try again';
    if (data && data.description) {
      text = data.description;
    }
    const errorsHTML = `<div class="errors">${text}</div>`;

    this.button.classList.remove(classes.loading);
    this.button.removeAttribute('disabled');
    this.errors.innerHTML = errorsHTML;
    slideDown(this.errors);
    setTimeout(() => {
      slideUp(this.errors);
    }, 5000);
  }

  updateHeaderTotal() {
    axios
      .get(`${window.theme.routes.cart}.js`)
      .then((response) => {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            detail: {
              cart: response.data,
            },
            bubbles: true,
          })
        );
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

const productAddSection = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.wrapper);
    els.forEach((el) => {
      sections[this.id].push(new ProductAddButton(el));
    });
  },
  onUnload: function () {
    sections[this.id].forEach((el) => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};

export {ProductAddButton, productAddSection};
